import React from 'react';
import SPPProgressBarPopover from 'chameleon/ui-stack/ui/assessments/spp-progress-bar';
import { Fragment } from 'react';

const SPPAnswerTipsRow = ({ title, assignment, item, children, students }) => {
  return (
    <Fragment>
      <tr className="border-bottom cursor-default">
        <td className="py-8 font-medium text-18 text-black py-7 flex-1">
          <div className="flex flex-row">
            <span className="font-normal ml-8 self-center">{title}</span>
          </div>
        </td>
        <td></td>
        <td></td>
        <td className="py-8 font-medium text-18 text-black pr-8 py-7 flex-1">
          <div className="flex justify-end cursor-pointer">
            <SPPProgressBarPopover
              isUnassigned={false}
              isActivePopover={true}
              assignment={assignment}
              item={item}
              forPartsAndTips={true}
              students={students}
            />
          </div>
        </td>
      </tr>
      {children}
    </Fragment>
  );
};

export default SPPAnswerTipsRow;
